import React from 'react';
import RecommendCityCard from '../RecommendCityCard';
import './styles.css';

const RecommendCityList = ({ name, cities}) => {
    return (
        <div>
            <h2 className="continent-name">{name}</h2>
            <div className="cities-list">
                {
                    cities.map((city) => {
                        return (
                            <RecommendCityCard {...city} key={city.name} />
                        )
                    })
                }
            </div>
        </div>
    );
};

export default RecommendCityList;
